<template>
  <div
    id="top"
    :class="componentClass"
    :style="componentStyle"
  >
    <warning-internet-explorer v-if="isInternetExplorer" />
    <wa-admin-bar />

    <slot name="tophat">
      <subscription-notices />
      <usage-notices />
      <web-awesome-release-notice v-if="isShowingWebAwesomeReleaseNotice" />
    </slot>

    <slot name="header" />

    <slot
      v-if="isShowingBandana"
      name="bandana"
    >
    </slot>

    <slot name="sweatband" />
    <slot name="content" />
    <slot name="sock" />
    <slot name="footer" />
    <slot name="overlay" />

    <cookie-consent />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SubscriptionNotices from 'app/components-wa/messages/SubscriptionNotices'
  import UsageNotices from 'app/components-wa/messages/UsageNotices'
  import WebAwesomeReleaseNotice from 'app/components-wa/messages/WebAwesomeReleaseNotice'
  import WarningInternetExplorer from './WarningInternetExplorer'
  import CookieConsent from 'app/components-wa/messages/CookieConsent'

  export default {
    name: 'Page',

    components: {
      WarningInternetExplorer,
      SubscriptionNotices,
      CookieConsent,
      UsageNotices,
      WebAwesomeReleaseNotice
    },

    props: {
      customStyle: {
        type: Object,
        default: () => {}
      },
      isShowingBandana: {
        type: Boolean,
        default: false
      },
      isShowingNewPackNotice: {
        type: Boolean,
        default: false
      },
      isShowingWebAwesomeReleaseNotice: {
        type: Boolean,
        default: false
      },
      viewSlug: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        isInternetExplorer: false
      }
    },

    computed: {
      ...mapGetters('kits', ['currentKits']),

      isSignedIn() {
        return this.$route.meta.isSignedIn
      },

      componentClass() {
        return [`app-container size-sm tablet:size-md ${this.viewSlug}`]
      },

      componentStyle() {
        return {
          ...{ '--desktop-grid-max-width': 'var(--laptop-grid-max-width)' },
          ...this.customStyle
        }
      },

      isShowingKitDisabledNotice() {
        return this.currentKits.length > 0 && this.currentKits[0].status === 'deactivated' && this.currentKits[0].shutdownDate !== null
      }
    },

    mounted() {
      this.isInternetExplorer = !!document.documentMode
    }
  }
</script>
